<div class="team-engage-content-container">
    <div class="full-width-height">
        <div data-ava-route="/" class="ava-iframe-container">
            <div class="spinner">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>
